// Shared type for dashboard response structure
export type DashboardResponseWithData<T> = {
  data: T[];
  lastUpdated?: string;
};

// Type guard function to check if data has the expected structure
export function isDashboardResponse<T>(data: unknown): data is DashboardResponseWithData<T> {
  return (
    data !== null &&
    typeof data === 'object' &&
    'data' in data &&
    Array.isArray((data as DashboardResponseWithData<T>).data)
  );
}
